const alert_system = {
  alert_json: '',
  title: '',
  time_stamp: '',
  body: '',
  cname: '',
  alert_html: '<button type="button" class="alert-button" data-bs-toggle="modal" data-bs-target="#alert_modal_"><i class="fa-solid fa-triangle-exclamation"></i> Penguin Alert <i class="fa-solid fa-triangle-exclamation"></i></button><div class="modal fade" id="alert_modal_" tabindex="-1" aria-labelledby="alert_modal_Label" aria-hidden="true"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><h2 class="alert-title modal-title fs-5" id="alert_modal_Label"></h2><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body alert-body"></div><div class="modal-footer"><time class="alert-time" utc-timestamp=""></time><button type="button" class="alert-refresh btn btn-secondary">Refresh</button><button type="button" class="btn btn-secondary alert-dismiss" data-bs-dismiss="modal">Dismiss</button></div></div></div></div>',
  selectors:{
    alert_title: '.alert-title',
    alert_body: '.alert-body',
    alert_timestamp: '.alert-time',
  },
  days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  getData: async function() {
    const url = "/feeds/penguin_alerts.json";
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      this.alert_json = await response.json();
      if(this.alert_json.length > 0){        
        $('#alert-box').html(this.alert_html);
        this.title = this.alert_json[0].title;
        this.time_stamp = this.alert_json[0].timestamp;
        this.body = this.alert_json[0].body;
        this.cname = this.alert_json[0].uuid;
        let date = new Date(0);
        let expires = new Date();
        this.refresh_alert(this.title, this.body, this.time_stamp, this.cname);
      }
    } catch (error) {
      console.error(error.message);
    }
  },
  refresh_alert: function(title, body, time_stamp){
    if(time_stamp != $(this.selectors.alert_timestamp).attr('utc-timestamp')){
      let utc_time = new Date(parseInt(time_stamp)*1000);
      $(this.selectors.alert_title).html(title);
      $(this.selectors.alert_body).html(body)
      $(this.selectors.alert_timestamp).attr('utc-timestamp', time_stamp);
      $(this.selectors.alert_timestamp).html('Last Updated: ' +utc_time.toLocaleString());
      this.checkCookie(this.cname, time_stamp);
    }
  },
  alert_init: function(){
    this.getData();
  },
  checkCookie: function(cname, cvalue){
    var date = new Date(parseInt(cvalue)*1000);
    //convert time from milliseconds
    date.setDate(date.getDate()+1);
    //add a day
    // console.log(document.cookie);
    //output cookie
    if(getCookie(cname) == ''){
      //if cookie doesn't exist, create a new cookie
      $('.alert-dismiss').on('click', function(){
        setCookie(cname, cvalue, date);
        //if the user dismisses the modal, set the cookie. 
      });
      $('.alert-button').trigger('click');
    }
    function setCookie(cname, cvalue, date) {
      // console.log(this.days[date.getDay()]);
      let expires = " expires="+date.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires + ";";
    }
    function getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  },
};

$(function(){
  alert_system.alert_init();
  $('.alert-refresh').on('click', function(){ 
    alert_system.getData();
  });
  window.setInterval(async function(){
    alert_system.getData();
  }, 60000);
});
